import * as angular from "angular";

angular
  .module('bringoz.admin.survey')
  .constant('Survey_PN', {
    database: 'survey',
    isBranchEntity: false
  });
